import { motion } from 'framer-motion';
import { FC } from 'react';

import uploadCloudImage from '../../../../assets/images/upload-cloud.svg';
import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';

type WorkspaceBrowserDropOverlayProps = {
  folderName: string;
};

// Over the browser while files are dragged in from the system, naming the folder they land in.
export const WorkspaceBrowserDropOverlay: FC<WorkspaceBrowserDropOverlayProps> = ({
  folderName,
}) => (
  <motion.div
    animate={{ opacity: 1 }}
    className="pointer-events-none absolute inset-4 flex items-center justify-center rounded-lg border-2 border-dashed border-brand-700"
    exit={{ opacity: 0 }}
    initial={{ opacity: 0 }}
    transition={{ duration: 0.15, ease: 'easeOut' }}
  >
    <div className="flex flex-col items-center gap-4">
      <img alt="" className="size-10" height={40} src={uploadCloudImage} width={40} />
      <div className="flex flex-col items-center rounded-xl bg-gradient-to-b from-brand-500 to-brand-800 px-6 py-2 shadow-2xl">
        <p className="text-[10px] font-medium leading-4 text-brand-50">
          <AppFormattedMessage id="DROP_FILES_TO_UPLOAD_TO" />
        </p>
        <p className="max-w-[320px] truncate text-sm font-[550] leading-5 text-white">
          {folderName}
        </p>
      </div>
    </div>
  </motion.div>
);
